<div class="FullHeightContentContainer">
    <div class="FullHeightContenttHeader">
        <table style="width:100%;">
            <tr>
                <td rowspan="2" style="padding-left:12px;width:1px;">
                    <span class="material-symbols-outlined" style="font-size: 32pt;">
                        group
                    </span>
                </td>
                <td style="padding-left:38px;">
                    <mat-card-title>SQL AccountContact Basic Testing.</mat-card-title>
                </td>
            </tr>
            <tr>
                <td style="padding-left:42px;">
                    <mat-card-subtitle>Test AccountContact Get and Save</mat-card-subtitle>
                </td>
            </tr>
        </table>
    </div>
    <div class="FullHeightContentContent">
        <form>
            <mat-form-field class="" style="width:220vw;padding-left: 12px;">
                <mat-label>AccountContactId</mat-label>
                <input matInput #message maxlength="256" [(ngModel)]="searchModel.AccountContactId" width="220" aceholder="Enter path-based ID" name="AccountContactId" />
                <mat-hint align="start">Enter fullpath such as creditor/2/accountcontact/INV-L7YXOXY3</mat-hint>
            </mat-form-field>
            <br />
            <mat-form-field style="width:96%;">
                <div style="display:none;">
                    <mat-label>AccountContactId</mat-label>
                    <input matInput #message maxlength="256" [(ngModel)]="searchModel.AccountContactId" width="220" aceholder="Enter path-based ID" name="AccountContactId" />
                    <mat-hint align="start">Enter fullpath</mat-hint>
                </div>
                <textarea [(ngModel)]="searchModel.ResultJson" name="ResultJson" style="font-family:'Courier New';margin-left:8px;width:99%;height:calc(100vh - 390px);overflow:auto;background-color:aliceblue;color:black;">
                </textarea>
            </mat-form-field>
        </form>
    </div>
    <div class="FullHeightContentFooter">
        <span class="ActionButtons">
            <button mat-button (click)="saveSqlAccountContact()">
                <span class="material-symbols-outlined">
                    save
                </span>
                SAVE
            </button>
            <button mat-button (click)="getSampleSqlQuery()">
                <span class="material-symbols-outlined">
                    dynamic_form
                </span>
                GENERATE CHECK QUERY !
            </button>
        </span>
    </div>
</div>
